import { motion } from "framer-motion";

const Hero = () => {
  const infoItems = [
    {
      title: "Formation",
      value: "MSU",
      icon: "🎓",
    },
    {
      title: "Durée",
      value: "2 ANS",
      icon: "🕒",
    },
    {
      title: "Coût",
      value: "55.000 DH",
      icon: "💰",
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900/20 to-slate-900 flex items-center justify-center w-full">
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0icmdiYSgyNTUsMjU1LDI1NSwwLjAyKSIgc3Ryb2tlLXdpZHRoPSIxIi8+PC9wYXR0ZXJuPjwvZGVmcz48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI2dyaWQpIi8+PC9zdmc+')] opacity-40"></div>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="relative w-full max-w-6xl mx-auto px-4 py-8 md:py-0"
      >
        <div className="text-center mb-12 md:mb-16">
          <motion.img
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8 }}
            src="https://screendy-cdn.fra1.cdn.digitaloceanspaces.com/platfrom-v2/_files/file_1750618808615_Screenshot2025-06-22at195825.png"
            alt="ENSAM Casablanca"
            className="object-contain h-[60px] w-[200px] mx-auto rounded-xl shadow-xl mb-8 overflow-hidden "
          />

          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.8 }}
            className="text-blue-400 text-lg md:text-xl font-medium tracking-wider uppercase mb-3 md:mb-4"
          >
            Master Spécialisé
          </motion.h2>
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.8 }}
            className="text-3xl md:text-6xl font-bold text-white mb-4 md:mb-6 leading-tight"
          >
            Intelligence Artificielle
            <br />
            <span className="bg-gradient-to-r from-blue-400 to-cyan-400 text-transparent bg-clip-text">
              & Internet des Objets
            </span>
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.8 }}
            className="text-base md:text-lg text-gray-300 max-w-2xl mx-auto px-2 md:px-0"
          >
            Un programme d'excellence conçu pour former les experts en IA et
            IoT. Développez des compétences de pointe dans les technologies
            émergentes.
          </motion.p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.8 }}
          className="max-w-2xl mx-auto mb-8 md:mb-12"
        >
          <div className="space-y-3 md:space-y-0 md:grid md:grid-cols-3 md:gap-8">
            {infoItems.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.6 + index * 0.1, duration: 0.5 }}
                className="flex items-center space-x-4 md:flex-col md:items-center md:space-x-0 bg-white/5 backdrop-blur-sm md:backdrop-blur-none p-4 md:p-0 rounded-lg md:rounded-none md:bg-transparent"
              >
                <span className="text-2xl md:text-3xl md:mb-2 md:hidden">
                  {item.icon}
                </span>
                <div className="flex flex-col items-start md:items-center">
                  <h3 className="text-blue-400 font-medium text-sm md:text-lg mb-0.5 md:mb-1">
                    {item.title}
                  </h3>
                  <p className="text-white text-base md:text-lg">
                    {item.value}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8, duration: 0.8 }}
          className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center px-4 md:px-0"
        >
          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            className="px-6 md:px-8 py-3 md:py-4 bg-gradient-to-r from-blue-600 to-blue-500 rounded-lg md:rounded-xl text-white font-semibold text-base md:text-lg hover:shadow-lg hover:shadow-blue-500/25 transition-all duration-300 w-full sm:w-auto"
            onClick={() => {
              document
                .getElementById("form")
                .scrollIntoView({ behavior: "smooth" });
            }}
          >
            Inscrivez-vous
          </motion.button>
          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            className="px-6 md:px-8 py-3 md:py-4 bg-white/5 backdrop-blur-lg rounded-lg md:rounded-xl text-blue-400 font-semibold text-base md:text-lg border border-blue-400/50 hover:bg-blue-400/10 transition-all duration-300 w-full sm:w-auto"
            onClick={() => {
              document
                .getElementById("details")
                .scrollIntoView({ behavior: "smooth" });
            }}
          >
            Découvrir le programme
          </motion.button>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default Hero;
